<template>
<div class="box">
    <div class="table__header p-3">
        <h4>Payment Invoices</h4>
    </div>
    <div class="row p-3">
        <div class="col-md-3">
            <div class="form-group">
              <label for="summary_for" class="form-label"> Summary For </label>
              <v-select
                    id="summary_for"
                    label="name"
                    index="slug"
                    :options="[
                        {
                            name:'Supplier',
                            slug:'supplier'
                        },
                        {
                            name:'Tour Manager',
                            slug:'tour_manager'
                        },
                        {
                            name:'Affiliate',
                            slug:'affiliate'
                        },
                    ]"
                    placeholder="Summary For"
                    v-model="paymentFilters.summary_for"
                />
            </div>
        </div>
        <div class="col-md-3" v-if="paymentFilters.summary_for">
            <template v-if="paymentFilters.summary_for == 'supplier'">
                <div class="form-group">
                    <label for="suppliers" class="form-label"> Suppliers </label>
                    <v-select
                            id="suppliers"
                            label="supplier_name"
                            index="id"
                            placeholder="Select Supplier"
                            :options="suppliers"
                            v-model="paymentFilters.summary_for_id"
                        />
                </div>
            </template>
            <template v-if="paymentFilters.summary_for == 'tour_manager'">
                <div class="form-group">
                    <label for="suppliers" class="form-label"> Tour manager </label>
                    <v-select
                            id="suppliers"
                            label="firstname"
                            index="id"
                            placeholder="Select Tour Manager"
                            :options="tourmanagers"
                            v-model="paymentFilters.summary_for_id"
                        />
                </div>
            </template>
            <template v-if="paymentFilters.summary_for == 'affiliate'">
                <div class="form-group">
                    <label for="suppliers" class="form-label"> Affiliate </label>
                    <v-select
                            id="suppliers"
                            label="name"
                            index="id"
                            placeholder="Select Affiliate"
                            :options="affiliates"
                            v-model="paymentFilters.summary_for_id"
                        />
                </div>
            </template>
        </div>
        <div class="col-md-3">
            <div class="form-group">
              <label for="" class="form-label">Payment Due </label>
                <date-range-picker v-model="paymentFilters.paymentDueDateRange" format="mm/dd/yyyy" opens="center" @update="checkOpenPicker" class="form-control">
                    <!-- header slot-->
                    <div slot="header" slot-scope="header" class="slot-date-range-picker">
                        <h3 class="m-0">Calendar header</h3> <span v-if="header.in_selection"> - in selection</span>
                    </div>
                    <!-- input slot (new slot syntax) -->
                    <template #input="picker">
                        {{ picker.startDate | date }} - {{ picker.endDate | date }}
                    </template>
                    <!-- date slot-->
                    <template #date="data">
                        <span class="small">{{ data.date | dateCell }}</span>
                    </template>
                    <!-- ranges (new slot syntax) -->
                    <template #ranges="ranges">
                        <div class="ranges">
                            <ul>
                            <li v-for="(range, name) in ranges.ranges" :key="name" @click="ranges.clickRange(range)">
                                <b>{{ name }}</b> <small class="text-muted">{{ range[0].toDateString() }} - {{ range[1].toDateString() }}</small>
                            </li>
                            </ul>
                        </div>
                    </template>
                    <!-- footer slot -->
                    <div slot="footer" slot-scope="data" class="slot-date-range-picker">
                        <div class="p-2">
                            <b class="text-black">Calendar footer</b> {{ data.rangeText }}
                        </div>
                        <div style="margin-left: auto">
                            <a @click="data.clickApply" v-if="!data.in_selection" class="btn btn-primary btn-sm">Choose current</a>
                        </div>
                    </div>
                </date-range-picker>
            </div>
        </div>
        <!-- <div class="col-md-2"></div> -->
        <div class="col-md-1" style="margin-top: 40px;">
            <button class="button button--large ms-2" @click="doSearch"><span>Search</span></button>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-md-12">
            <vdtnet-table
                ref="table"
                :fields="fields"
                :opts="options"
                @viewSupplier="viewSupplier"
                @viewSupplierPaymentInvoice="viewSupplierPaymentInvoice"
                @viewTourManager="viewTourManager"
                @viewAffiliate="viewAffiliate"
                @openRecordPaymentModal="openRecordPaymentModal"
                @openAffiliatePaymentModal="openAffiliatePaymentModal"
                :key="paymentTableKey"
                >
            </vdtnet-table>
        </div>
    </div>
    
    <div class="modal__bg" v-if="showPaymentModal == true"></div>
    <div class="modal" v-if="showPaymentModal == true">
        <RecordPaymentModal :paymentfor="invoiceForTag" 
                            :paymentForObject="invoiceFor"
                            :paymentforid="invoiceFor.id" 
                            :selectedInvoice="selectedInvoice"
                            :recordedPayments="selected_invoice_payments"
                            @syncPayments="syncPayments"/>
        <button type="button" class="icon icon--unlink" v-on:click="showPaymentModal = false">Close</button>
    </div>

    <!-- Artwork Products Modal -->
    <div class="modal__bg" v-if="showArtworkPaymentModal == true"></div>
    <div class="modal" v-if="showArtworkPaymentModal == true">
        <AdvertisementInvoices :advertiseSizes="advertise_sizes"
            :affiliateName="selectedAffiliate.name"
            :affiliateID="selectedAffiliate.id"        
            :products="products" 
            :advertisement="selectedAdvertisement"
            @syncProducts="syncProducts"   />
            <button type="button" class="icon icon--unlink" v-on:click="showArtworkPaymentModal = false">Close</button>
    </div>

    <!-- Affiliate PaymentModal -->
    <div class="modal__bg" v-if="showAffiliatePaymentModal == true"></div>
    <div class="modal modal-md" style="max-height: 400px;" v-if="showAffiliatePaymentModal == true">
        <AdvertisementInvoicePayment 
            :affiliatePaymnetDetails="selected_affiliate_addword_payment"
            @closeModal="closeAffiliatePaymentModal"/>
        <button type="button" class="icon icon--unlink" v-on:click="showAffiliatePaymentModal = false">Close</button>
    </div>
</div>
</template>

<script>

import 'datatables.net'
import 'datatables.net-select'
import VdtnetTable from 'vue-datatables-net'

import moment from 'moment';

import RecordPaymentModal from '@/components/RecordPaymentModal.vue'
import AdvertisementInvoices from '@/components/Affiliate/AdvertisementInvoices'
import AdvertisementInvoicePayment from '@/components/Affiliate/AdvertisementInvoicePayment'

export default {
    name: 'PaymentInvoices',
    components: {
        VdtnetTable,
        RecordPaymentModal,
        AdvertisementInvoices,
        AdvertisementInvoicePayment
    },
    props: {
        suppliers : Array,
        tourmanagers: Array,
        affiliates: Array,
        advertise_sizes:Array
    },
    computed: {
        selectedSummaryFor() {
            if (!this.paymentFilters.summary_for) {
                this.paymentFilters.selected_supplier_id = null    
                this.paymentFilters.selected_tour_manager_id = null    
            }
        }  
    },
    data() {
        return {
            paymentTableKey: 0,
            options: {
                ajax: {
                    url: this.$api + 'summary/payment-invoice?summary_for=supplier',
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': localStorage.getItem('token')
                    }
                },
                responsive: false,
                processing: true,
                searching: true,
                searchDelay: 1500,
                destroy: true,
                ordering: false,
                lengthChange: true,
                serverSide: true,
                dom: 'rtlip',
                autoWidth: false,
                lengthMenu: [ [5, 25, 50, 100, 500], [5, 25, 50, 100, 500] ],
                pageLength: 25,
                select: {
                    style: 'multi'
                }
            },
            fields: {
                supplier_id: {
                    searchable: false,
                    label: 'Supplier/Tour manager/Affiliate',
                    render: (data, type, row, meta) => {
                        if (row.summary_for == 'supplier') {
                            return  `<a href="/suppliers/edit/${ row.summary_for_object.id }" data-action="viewSupplier">${ row.summary_for_object.supplier_name }</a>`   
                        }

                        if (row.summary_for == 'tour_manager') {
                            return  `<a href="/tour-manager/edit/${ row.summary_for_object.id }" data-action="viewTourManager">${ row.summary_for_object.firstname } ${ row.summary_for_object.lastname }</a>`   
                        }

                        if (row.summary_for == 'affiliate') {
                            return  `<a href="/affiliate/edit/${ row.summary_for_object.id }" data-action="viewAffiliate">${ row.summary_for_object.name }</a>`   
                        }
                        
                    }
                },
                invoice_number: {
                    searchable: false,
                    label: 'Invoice Number',
                    render: (data, type, row, meta) => {
                        return (data) ? data : '--'
                    }
                },
                payment_due_date: {
                    searchable: false,
                    label: 'Payment Due Date',
                    render: (data) => {
                        return moment(String(data)).format('DD/MM/YYYY')
                    }
                },
                invoice_amount: {
                    searchable: false,
                    label: 'Total Amount',
                    render: (data, type, row, meta) => {
                        return this.$options.filters.CurrencySymbol(row.currency_type) + Number(data).toFixed(2)
                    }
                },
                due_amount: {
                    searchable: false,
                    label: 'Due Amount',
                    render: (data, type, row, meta) => {
                        return `<strong>${this.$options.filters.CurrencySymbol(row.currency_type) + Number(data).toFixed(2)}</strong>`
                    }
                },
                id: {
                    searchable: false,
                    label: 'Record Payment',
                    render: (data, type, row, meta) => {
                        if (['supplier', 'tour_manager'].includes(row.summary_for) ) { 
                            return `
                                <button class="button" data-action="openRecordPaymentModal"> Payment</a>
                                <button class="btn btn-outline-info ms-2" data-action="viewSupplierPaymentInvoice"> 
                                    <i class="icon icon--eye"><</i> 
                                </button>
                            `
                        } else {
                            return `
                                <button class="button btn-warning" data-action="openRecordPaymentModal"> Product </a>
                                &nbsp;
                                <button class="button" data-action="openAffiliatePaymentModal"> Payment </a>
                            `
                        }
                    }
                }
            },
            paymentFilters: {
                summary_for:'supplier',
                paymentDueDateRange: {
                    startDate : '',
                    endDate : '',
                },
            },
            selectedInvoice: {},
            invoiceFor : null,
            invoiceForTag: null,
            showPaymentModal: false,
            showArtworkPaymentModal:false,
            showAffiliatePaymentModal:false,
            selected_invoice_payments: [],
            selected_affiliate_addword_payment: {},
            selectedAdvertisement: [],
            selectedAffiliate:null,
            products:[]
        }
    },
    filters: {
        dateCell (value) {
            let dt = new Date(value)
            return dt.getDate()
        },
        date (val) {
            return val ? val.toDateString() : ''
        }
    },
    methods: {
        checkOpenPicker() {
            this.paymentFilters.paymentDueDateRange.startDate = moment(this.paymentFilters.paymentDueDateRange.startDate).format('YYYY-MM-DD')
            this.paymentFilters.paymentDueDateRange.endDate = moment(this.paymentFilters.paymentDueDateRange.endDate).format('YYYY-MM-DD')
        },
        viewSupplier(data) {
            this.$router.push({ name: 'supplier-edit', params: { id: data.summary_for_object.id }})
        },
        viewSupplierPaymentInvoice(data) {
            // console.log('viewSupplierPaymentInvoice clicked', data);
            this.$router.push({ name: 'supplier-edit', params: { id: data.summary_for_object.id } , query: { invoice_id: data.id }})
        },
        viewTourManager(data) {
            this.$router.push({ name: 'edit-tour-manager', params: { id: data.summary_for_object.id }})
        },
        viewAffiliate(data) {
            this.$router.push({ name: 'affiliate-edit', params: { id: data.summary_for_object.id }})
        },
        openRecordPaymentModal(data) {
            console.log(data);
            let self = this
            this.selectedInvoice = data
            this.invoiceForTag = data.summary_for
            this.invoiceFor = data.summary_for_object

            self.$store.dispatch('setLoadStatus')
            fetch(`${self.$api}invoice/get-invoice-payments`, {
                method: 'POST',
                body: JSON.stringify({
                    'payment_for': this.invoiceForTag,
                    'payment_for_id': data.summary_for_object.id,
                    'invoice_id': (this.invoiceForTag == 'affiliate') ? data.advertisement_id : data.id,
                }),
                headers:{
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                self.errors = response.errors
                if (response.status) {
                    if (this.invoiceForTag == 'affiliate') {
                        this.selectedAdvertisement = data
                        this.products = response.recorded_payments
                        this.selectedAffiliate = data.summary_for_object
                        this.showArtworkPaymentModal = true
                    } else {
                        this.selected_invoice_payments = response.recorded_payments;        
                        this.showPaymentModal = true
                    }

                } else if (response.errors) {
                    
                }
                self.$store.dispatch('setLoadStatus')
            });
        },
        openAffiliatePaymentModal(data) {
            this.selected_affiliate_addword_payment = data.modal_payment_details
            this.showAffiliatePaymentModal = true
        },
        closeAffiliatePaymentModal() {
            this.doSearch()
            this.showAffiliatePaymentModal = false
        },
        doSearch () {
            const ajaxUrl = this.$api + 'summary/payment-invoice'

            const queryString = new URLSearchParams();

            if(this.paymentFilters.summary_for) {
                queryString.set('summary_for', this.paymentFilters.summary_for);
            } else {
                this.paymentFilters.summary_for = 'supplier'
                queryString.set('summary_for', this.paymentFilters.summary_for);
            }

            if(this.paymentFilters.summary_for_id) {
                queryString.set('summary_for_id', this.paymentFilters.summary_for_id);
            }

            if(this.paymentFilters.paymentDueDateRange.startDate && this.paymentFilters.paymentDueDateRange.endDate){
                queryString.set('due_date_start', this.paymentFilters.paymentDueDateRange.startDate);
                queryString.set('due_date_end', this.paymentFilters.paymentDueDateRange.endDate);
            }

            const urlWithParams = `${ajaxUrl}?${queryString.toString()}`;

            // Update the datatable's AJAX URL with the Start Date & End Date query parameters
            this.options.ajax.url = urlWithParams;

            // Increment the tableKey to force re-render and fetch new data
            this.paymentTableKey++;
        },
        syncPayments(paymentObject) {
            this.selected_invoice_payments = paymentObject;
            this.doSearch()
        },
        syncProducts (productObject) {
            this.products = productObject
            this.doSearch()
        }
        
    }
}
</script>

<style scoped>
.slot-date-range-picker {
  background-color: #aaa;
  padding: 0.5rem;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.slot-date-range-picker h3 {
  font-size: 1.0625rem;
}

.text-black {
  color: #000;
}
</style>